module.exports = __webpack_public_path__ + "assets/img/activityRule.b5cd1169.png";